<template>
  <div class="w-100">
    <div class="mt- d-flex align-self-start">
      <div
        class="position-relative align-self-center d-flex align-items-center align-self-center"
      >
        <div
          class="circle-number d-flex justify-content-center align-items-center"
        >
          <span>{{ number }}</span>
        </div>
      </div>
      <div class="pl-3 d-flex">
        <div class="align-self-start mt-1">
          <h2 class="size-1_4 m-0 pb-1">
            <strong v-text="$ml.get('programPolicy')"
              >Política do Programa</strong
            >
          </h2>
          <p class="d-flex align-items-center">
            <span
              class="align-self-center"
              v-text="$ml.get('aGoodPolicAvoids')"
            >
              Uma boa política evita problemas, caso tenha algum problema nos
              consulte.
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>
    <!-- Descrição da politica -->
    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>
      <div class="d-flex flex-column w-100 mr-3">
        <p class="pl-3 mb-3 " v-text="$ml.get('nowTellUsLittle')">
          Agora nos fale um pouco da política do programa!
        </p>
        <div class="card card-body ml-3 pl-3 d-flex w-100 pr-3">
          <form>
            <div class="col">
              <svg v-show="!htmlText" @click="viewHtml()" width="24" height="24" class="ico-view-report" > 
                <image xlink:href="../../../assets/icons/eye.svg" width="24" height="24" /> 
              </svg>
              <svg v-show="htmlText" @click="htmlText = ''" width="24" height="24" class="ico-view-report" >
                <image xlink:href="../../../assets/icons/eye-slash.svg" width="24" height="24" />
              </svg>
              <textarea v-show="!htmlText" class="form-control-textarea w-100 text-are-mark" :value="policy" @input="$emit('update:policy', $event.target.value)" ref="textarea" @keyup="controlTextArea()" @focus="controlTextArea()" placeholder="Adicione a política do programa..." >
              </textarea>
              <div
                v-show="htmlText"
                class="form-control w-100 h-100"
                v-html="htmlText"
              ></div>
            </div>

            <transition name="fade">
              <label
                v-if="errorPolicy"
                class="lblError"
                v-text="
                  $ml
                    .with('f', 3)
                    .with('l', '30.000')
                    .get('programPolicyMustBeBetweenAndCharacters')
                "
                >A política do programa deve ter entre 3 e 30.000
                caracteres!</label
              >
              <label
                v-if="policyMaxLengt"
                class="lblError"
                v-text="$ml.with('30.000').get('maximumLengthIsCharacters')"
                >Tamanho máximo é de 30.000 caracteres</label
              >
            </transition>
          </form>
        </div>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-5"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Config",
  props: {
    number: {
      type: String,
      required: true,
    },
    htmlText: {
      type: String,
      required: false,
    },
    policy: {
      type: String,
      required: false,
    },
    errorPolicy: {
      type: Boolean,
      required: false,
    },
  },

  components: {},
  data() {
    return {
      policyMaxLengt: false,
    };
  },

  watch: {
    typeProgram: function() {
      if (this.typeProgram.id) this.$emit("verify-Plan", this.typeProgram.id);
    },

    slug(text) {
      if (text) this.slug = text.replace(/[^a-zA-Z0-9-]*$/i, "");
    },
  },
  mounted() {
    const { textarea } = this.$refs;
    textarea.style.height = "480px";
  },
  methods: {
    viewHtml() {
      this.htmlText = "";
      this.htmlText = this.$utils.convertMarkedOld(this.policy);
    },
    controlTextArea() {
      const { textarea } = this.$refs;
      textarea.style.height = textarea.scrollHeight + "px";

      if (this.policy.length > 29900) {
        this.policy = this.policy.substring(0, 29900);
        this.policyMaxLengt = true;
      } else {
        this.policyMaxLengt = false;
      }
    },
  },
};
</script>
